var stripPart = document.querySelectorAll('.green-strip-part');

if(stripPart) {
    stripPart.forEach(function(container) {
        let id = container.getAttribute("data-id");
        let activated = false;
        const sectionID = document.querySelector(`#green-strip-${id}`);
        window.addEventListener('scroll', () => {
            let number = container.querySelector(`#numberGreenStrip-${ id }`);
            var scrollPosition = window.scrollY || window.pageYOffset;
            var divOffsetTop = sectionID.offsetTop;
            var divHeight = sectionID.offsetHeight;
            var divOffsetBottom = divOffsetTop + divHeight;
            if(!number) return;
            if(number.getAttribute('data-count') == '0') {
                const par = number.parentElement;
                par.style.display = 'none';
            }
            if(
                scrollPosition >= divOffsetTop - 400 && scrollPosition <= divOffsetBottom
               && activated === false
           ){
               activated = true;
               let startNum = 0,
                   endNum = number.getAttribute('data-count'),
                   nSecond = 6,
                   resolutionMS = 100,
                   deltaNum = (endNum - startNum) / (1000 / resolutionMS) / nSecond;
               let countInterval = setInterval(function(){
                   var x = startNum.toLocaleString(undefined, {
                   minimumFractionDigits: 0,
                   maximumFractionDigits: 0
                   });
                   number.innerHTML = "$" + x.toString().replace('.',',');

                   if (startNum >= endNum) clearInterval(countInterval);

                   startNum += deltaNum;
                   startNum = Math.min(startNum, endNum);
               }, resolutionMS);
               if (startNum >= endNum) clearInterval(countInterval);
           }
        });
    })
}

// if(document.querySelector("#numberGreenStrip")){
//     let activated = false;
//     window.addEventListener('scroll', () => {
//         const containers = document.querySelectorAll(".section-green-strip");
//         containers.forEach((container) => {
//             if(container.querySelector("#numberGreenStrip").getAttribute('data-count') == '0'){
//                 const par = container.querySelector("#numberGreenStrip").parentElement;
//                 par.style.display = 'none';
//             }
//             if(
//                  container.offsetTop - container.offsetHeight - 450 &&  container.offsetTop - container.offsetHeight - 400
//                 && activated === false
//             ){
//                 activated = true;
//                 let startNum = 0,
//                     endNum = container.querySelector("#numberGreenStrip").getAttribute('data-count'),
//                     nSecond = 6,
//                     resolutionMS = 100,
//                     deltaNum = (endNum - startNum) / (1000 / resolutionMS) / nSecond;
//                 let countInterval = setInterval(function(){
//                     var x = startNum.toLocaleString(undefined, {
//                     minimumFractionDigits: 0,
//                     maximumFractionDigits: 0
//                     });
//                     container.querySelector("#numberGreenStrip").innerHTML = "$" + x.toString().replace('.',',');

//                     if (startNum >= endNum) clearInterval(countInterval);

//                     startNum += deltaNum;
//                     startNum = Math.min(startNum, endNum);
//                 }, resolutionMS);
//                 if (startNum >= endNum) clearInterval(countInterval);
//             }
//         });
//     });
// }